export default "__VITE_ASSET__BYtXcOuI__"